import FadeText from './FadeText';
export { default as FadeText } from './FadeText';
export { Text } from './Text';

export default FadeText;
